import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import Icon from './Icon';

const CaseStudyCard = ({ project, featured = false }) => (
  <article className="work-card">
    <div className="work-visual" data-visual={project.visual}>
      {project.image ? (
        <div className="work-screen work-screen-image">
          <img
            src={project.image.replace('.webp', '-800.webp')}
            srcSet={`${project.image.replace('.webp', '-800.webp')} 800w, ${project.image} 1600w`}
            sizes={featured ? '(max-width: 760px) 92vw, 720px' : '(max-width: 760px) 92vw, 460px'}
            width="800"
            height="500"
            alt={`${project.title} screenshot`}
            loading="lazy"
            decoding="async"
          />
        </div>
      ) : (
        // TODO: replace with a real project screenshot
        <div className="work-screen" aria-hidden="true">
          <div className="work-screen-head">
            <Icon name={project.visual} />
            {project.title}
          </div>
          <div className="work-screen-line" />
          <div className="work-screen-line mid" />
          <div className="work-screen-line short" />
          <div className="work-screen-blocks">
            <span /><span /><span />
          </div>
        </div>
      )}
    </div>
    <div className="work-body">
      <span className="work-category">{project.category}</span>
      <h3>{project.title}</h3>
      <p>{project.summary}</p>
      <ul className="tag-list">
        {project.tags.map((tag) => (
          <li key={tag}>{tag}</li>
        ))}
      </ul>
      {project.url && (
        <a href={project.url} target="_blank" rel="noopener noreferrer" className="text-link work-link">
          Visit live site <FiArrowUpRight />
        </a>
      )}
    </div>
  </article>
);

export default CaseStudyCard;
